import { useCallback } from 'react';

const formattingRules = [
  { decimals: 1, divisor: 100_000, scaleFactor: 1_000_000, suffix: 'M', threshold: 1_000_000 },
  { decimals: 0, divisor: 1000, scaleFactor: 1, suffix: '', threshold: 10_000 },
  { decimals: 0, divisor: 1000, scaleFactor: 1, suffix: '', threshold: 1000 },
  { decimals: 0, divisor: 100, scaleFactor: 1, suffix: '', threshold: 100 },
  { decimals: 0, divisor: 10, scaleFactor: 1, suffix: '', threshold: 10 },
  { decimals: 0, divisor: 1, scaleFactor: 1, suffix: '', threshold: 0 },
] as const;

export const useGetFormatMembersCount = () =>
  useCallback(({ count }: { count: number }) => {
    const rule = formattingRules.find(({ threshold }) => count >= threshold);

    if (!rule) {
      throw new Error('No formatting rule found for count');
    }

    const { decimals, divisor, scaleFactor, suffix } = rule;
    const formattedNumber = (Math.floor(count / divisor) * divisor) / scaleFactor;

    const numberPart =
      decimals > 0
        ? formattedNumber.toFixed(decimals)
        : // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
          new Intl.NumberFormat(navigator.language ?? 'en-US').format(formattedNumber);

    return count < 10 ? numberPart : `${numberPart}${suffix}+`;
  }, []);
